export default __webpack_public_path__ + "static/media/set_7_Video-6.4104ba5f.svg";